import { SVGProps } from './SVGProps';

export const ArrowLeft = (props: SVGProps) => {
  return (
    <svg
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4167 10H5M5 10L10 5M5 10L10 15"
        stroke={props.color || 'currentColor'}
        strokeWidth={props.strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
